module.exports = __webpack_public_path__ + "img/google-location.7bd09775.png";